// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"54e6ab86","485":"d225aa3c","488":"764ef6fb"}[chunkId] + ".chunk.js";
};